import { render, staticRenderFns } from "./PanelHeaderContent.vue?vue&type=template&id=7b900b2f&"
import script from "./PanelHeaderContent.vue?vue&type=script&lang=js&"
export * from "./PanelHeaderContent.vue?vue&type=script&lang=js&"
import style0 from "./PanelHeaderContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports